/**
 * "input like" component
 * including number/password/...
 * @Input() label: string;
 * @Input() type: string;
 * @Input() name: string;
 * @Input() placeholder: string;
 * @Input() colorstyle: string;
 * @Input() linestyle: string;
 */
import { Component, Input } from '@angular/core';

@Component({
    selector: 'text-input',
    template: `
        <label [ngClass]="{'onDark': colorstyle == 'onDark'}">
            <span class="label" *ngIf="label">{{label}} :</span>
            <br *ngIf="linestyle == 'breakLine'">
            <input [name]="name"
                   [type]="type"
                   [placeholder]="placeholder"
                   #focusable
                   autofocus>
        </label>
    `
})
export class TextInput {
    @Input()
    public label: string;
    @Input()
    public type: string;
    @Input()
    public name: string;
    @Input()
    public focus: boolean;
    @Input()
    public placeholder: string;
    @Input()
    public colorstyle: string;
    @Input()
    public linestyle: string;
}
